var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1593_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9931 1.25195C12.2786 1.25195 12.5393 1.41403 12.6657 1.67003L15.5771 7.56929L22.0867 8.51271C22.3693 8.55368 22.6042 8.75165 22.6924 9.02331C22.7807 9.29497 22.7069 9.59315 22.5022 9.79238L17.785 14.3841L18.8973 20.8681C18.9456 21.1497 18.8298 21.4341 18.5987 21.6019C18.3675 21.7697 18.0611 21.7916 17.8085 21.6585L11.9997 18.5975L6.17712 21.6588C5.92443 21.7916 5.61823 21.7695 5.38726 21.6017C5.1563 21.4339 5.04063 21.1495 5.0889 20.8681L6.20118 14.3841L1.48397 9.79238C1.2793 9.59315 1.20555 9.29497 1.29377 9.02331C1.38199 8.75165 1.61686 8.55368 1.89953 8.51271L8.40913 7.56929L11.3205 1.67003C11.4469 1.41403 11.7076 1.25195 11.9931 1.25195ZM11.9931 3.69663L9.57965 8.58687C9.47037 8.80832 9.25907 8.96178 9.01467 8.9972L3.62066 9.77894L7.53024 13.5845C7.70726 13.7568 7.78807 14.0053 7.7463 14.2488L6.82425 19.6239L11.6511 17.0861C11.8698 16.9711 12.1311 16.9712 12.3497 17.0864L17.1616 19.6221L16.2399 14.2488C16.1981 14.0053 16.2789 13.7568 16.456 13.5845L20.3655 9.77894L14.9715 8.9972C14.7271 8.96178 14.5158 8.80832 14.4065 8.58687L11.9931 3.69663Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1593_2552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarStroke);
export default __webpack_public_path__ + "static/media/Star Stroke.7c855e808d917135b84762d9731b971d.svg";
export { ForwardRef as ReactComponent };